import type { DatasyncClient } from '@ps-int/datasync-client';

import { getDatasyncClient } from '../../helpers/datasync';

const PROMOZAVR_DATASYNC_DB = 'ps';
const PROMOZAVR_DATASYNC_COLLECTION = 'promo';

export function getPromozavrDatasyncClient(userUid?: string): DatasyncClient {
    return getDatasyncClient({
        db: PROMOZAVR_DATASYNC_DB,
        collection: PROMOZAVR_DATASYNC_COLLECTION,
        userUid,
    });
}
